import React from "react";
import { patchStatusCafe } from "../../../../../api/cafe.api";

interface ModalProps {
  isOpen: boolean;
  status: string;
  onClose: (close: string) => void;
  fetchData: () => void;
}

const OpenCafe: React.FC<ModalProps> = ({
  status,
  isOpen,
  onClose,
  fetchData,
}) => {
  if (!isOpen) return null;
  const handleClick = () => {
    patchStatusCafe(status);
    onClose("confirm");
    fetchData();
  };

  const renderStatus = (status: string) => {
    if (status === "cafe-open") {
      return "Open Cafe";
    } else if (status === "bar-open") {
      return "Open Bar";
    } else {
      return "Close Cafe and Bar";
    }
  };
  return (
    <div className="h-screen w-full fixed left-0 top-0 bg-black bg-opacity-25 font-nunito">
      <div className="relative w-full h-full flex flex-col justify-center items-center">
        <div className="mx-[13px] w-11/12 md:w-3/4 h-[155px] md:h-[200px] border-0 rounded-lg shadow-lg relative flex flex-col   bg-white ">
          <div className="flex items-center justify-between mx-16 my-16 ">
            <div className="font-semibold text-center text-16 md:text-20">
              {renderStatus(status)}?
            </div>
            {/* <button className="flex justify-start" onClick={onClose}>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.3 0.709971C12.91 0.319971 12.28 0.319971 11.89 0.709971L6.99997 5.58997L2.10997 0.699971C1.71997 0.309971 1.08997 0.309971 0.699971 0.699971C0.309971 1.08997 0.309971 1.71997 0.699971 2.10997L5.58997 6.99997L0.699971 11.89C0.309971 12.28 0.309971 12.91 0.699971 13.3C1.08997 13.69 1.71997 13.69 2.10997 13.3L6.99997 8.40997L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L8.40997 6.99997L13.3 2.10997C13.68 1.72997 13.68 1.08997 13.3 0.709971Z"
                  fill="#292929"
                />
              </svg>
            </button> */}
          </div>
          <div className="relative mx-16 flex-auto  ">
            <p className="flex text-slate-500 text-base md:text-20 pb-16 leading-relaxed">
              Click confirm to{" "}
              <span className=" ml-4 font-semibold">
                {renderStatus(status)}
              </span>
            </p>
            <div className="w-full flex flex-row justify-center md:mt-[15px] gap-4 md:gap-16">
              <button
                className="h-48 w-full  text-secondary-S600 bg-netural-N40 rounded-lg  text-14 md:text-18"
                onClick={() => onClose("close")}
              >
                {" "}
                Close
              </button>
              <button
                className="h-48 w-full bg-primary-Base text-white rounded-lg  text-14 md:text-18"
                onClick={handleClick}
              >
                {" "}
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenCafe;
